import React from 'react';
import strings from "../../../localization";
import { getError, hasError } from "../../../functions/Validation";
import { Button, TextField } from "@material-ui/core";

const StonecutterForm = ({
  onSubmit,
  onCancel,
  onChange,
  errors,
  data,
  isDisabled
}) => {
  return (

    <form id='user-form'>
      <TextField
        label={strings.stonecutter.form.code + "*"}
        error={hasError(errors, 'code')}
        helperText={getError(errors, 'code')}
        fullWidth
        autoFocus
        name='code'
        onChange={onChange}
        margin="normal"
        defaultValue={data.code}
        value={data.code}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isDisabled}
      />
      <TextField
        label={strings.stonecutter.form.name + "*"}
        error={hasError(errors, 'name')}
        helperText={getError(errors, 'name')}
        fullWidth
        name='name'
        onChange={onChange}
        margin="normal"
        defaultValue={data.name}
        value={data.name}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isDisabled}
      />
      <TextField
        label={strings.stonecutter.form.type + "*"}
        error={hasError(errors, 'type')}
        helperText={getError(errors, 'type')}
        fullWidth
        name='type'
        onChange={onChange}
        margin="normal"
        defaultValue={data.type}
        value={data.type}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isDisabled}
      />
      <TextField
        multiline={true}
        rowsMax={5}
        label={strings.stonecutter.form.address}
        error={hasError(errors, 'address')}
        helperText={getError(errors, 'address')}
        fullWidth
        name='address'
        onChange={onChange}
        margin="normal"
        defaultValue={data.address}
        value={data.address}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isDisabled}
      />
      <TextField
        label={strings.stonecutter.form.city}
        error={hasError(errors, 'city')}
        helperText={getError(errors, 'city')}
        fullWidth
        name='city'
        onChange={onChange}
        margin="normal"
        value={data.city ? data.city : ''}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isDisabled}
      />
      <TextField
        label={strings.stonecutter.form.street}
        error={hasError(errors, 'street')}
        helperText={getError(errors, 'street')}
        fullWidth
        name='street'
        onChange={onChange}
        margin="normal"
        value={data.street ? data.street : ''}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isDisabled}
      />
      <TextField
        label={strings.stonecutter.form.streetNumber}
        error={hasError(errors, 'streetNumber')}
        helperText={getError(errors, 'streetNumber')}
        fullWidth
        name='streetNumber'
        onChange={onChange}
        margin="normal"
        value={data.streetNumber ? data.streetNumber : ''}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isDisabled}
      />
      <TextField
        label={strings.stonecutter.form.telephone}
        error={hasError(errors, 'telephone')}
        helperText={getError(errors, 'telephone')}
        fullWidth
        name='telephone'
        onChange={onChange}
        margin="normal"
        value={data.telephone ? data.telephone : ''}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isDisabled}
      />
      <TextField
        label={strings.stonecutter.form.identityCardNumber}
        error={hasError(errors, 'identityCardNumber')}
        helperText={getError(errors, 'identityCardNumber')}
        fullWidth
        name='identityCardNumber'
        onChange={onChange}
        margin="normal"
        value={data.identityCardNumber ? data.identityCardNumber : ''}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isDisabled}
      />
      <TextField
        multiline={true}
        rowsMax={5}
        label={strings.stonecutter.form.note}
        error={hasError(errors, 'note')}
        helperText={getError(errors, 'note')}
        fullWidth
        name='note'
        onChange={onChange}
        margin="normal"
        defaultValue={data.note}
        value={data.note}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isDisabled}
      />

      {
        !isDisabled &&
        <div className='submit-container'>
          <Button variant="contained" color="primary" onClick={onSubmit}>
            {strings.stonecutter.form.ok}
          </Button>
          <Button variant="contained" color="secondary" onClick={onCancel}>
            {strings.stonecutter.form.cancel}
          </Button>
        </div>
      }
    </form>
  )
};

export default StonecutterForm;